import { Theme, Typography, makeStyles } from '@material-ui/core'
import { AutoCompleteInputMultiSelect } from 'bpm/pages/ProductsPage/AddProductDialog/AutoCompleteInput'
import React, { FC, useCallback } from 'react'

const useStyles = makeStyles((theme: Theme) => ({
    userFilterInput: {
        flex: 8,
        marginTop: theme.spacing(1),
        marginRight: theme.spacing(1),
        '& .MuiAutocomplete-root, .MuiInputBase-root ': {
            backgroundColor: theme.palette.common.white,
        },
    },
}))

const UserFilterInput: FC<{
    disabled: boolean
    users: string[]
    setUsers: (userValues: string[]) => void
    selectedUsers: string[]
}> = ({ disabled, users, setUsers, selectedUsers }) => {
    const classes = useStyles()

    const noop = useCallback(() => {}, [])

    const setSelectedUsers = useCallback(
        (_, value) => {
            setUsers(value)
        },
        [setUsers]
    )

    return (
        <Typography
            className={classes.userFilterInput}
            data-testid="userFilter"
            component="div"
        >
            <AutoCompleteInputMultiSelect
                disabled={disabled}
                name="userFilter"
                data-testid="notesUserFilter"
                placeholder="Type or select users..."
                noLabel
                items={users}
                valid={true}
                handleChange={setSelectedUsers}
                selectedValues={selectedUsers}
                handleInputChange={noop}
            />
        </Typography>
    )
}
export default UserFilterInput
